import {createReducer, call, onSuccess} from 'actionware';
import jwtDecode from 'jwt-decode';
import camelcaseKeys from 'camelcase-keys';

import {ROLES} from '../constants';
import api, {tryGetPersistedAuth} from './services/api';
import analytics from '../features/analytics/index';
import {fetch} from './customers';

// state tree
const initialState = {
  user: null,
};

export const getInitialState = () => {
  return {
    ...initialState,
    user: tryGetPersistedAuth(),
  };
};

// actions/action creators
export const login = async credentials => {
  try {
    const result = await api.authenticate(credentials);

    return camelcaseKeys(jwtDecode(result.authToken));
  } catch (error) {
    return Promise.reject(error);
  }
};

export const refreshIdentity = async () => await api.get('users/me');

export const logout = () => {};

// reducer
const reducer = createReducer(initialState)
  .on(login, (state, user) => ({
    ...state,
    user,
  }))
  .on(logout, state => ({
    ...state,
    user: null,
  }));

// side-effects
export const onLoginSuccess = ({payload: user}) => {
  analytics.identify(user.id);

  if (user.role === ROLES.SYSTEM_ADMIN) {
    call(fetch);
  }
};

export const onLogoutSuccess = ({payload: user}) => {
  analytics.reset();
  localStorage.removeItem('authState');
};

onSuccess(login, onLoginSuccess);
onSuccess(logout, onLogoutSuccess);

export default reducer;
